import PropTypes from 'prop-types';
import React from 'react';
import { questionKey } from './reducer';
import { matrixWhyChange } from './actions';
import { connect } from 'react-redux';
import WhyField from './WhyField';

const MatrixWhyField = ({
  add_why,
  colSpan,
  why_text,
  name,
  rowName,
  ...props
}) =>
  add_why ? (
    <tr>
      <td colSpan={colSpan} className="why_row">
        <label className="srv-q-why text-left">
          {why_text}{' '}
          <WhyField add_why={add_why} name={`${name}-${rowName}`} {...props} />
        </label>
      </td>
    </tr>
  ) : null;

MatrixWhyField.propTypes = {
  add_why: PropTypes.bool,
  colSpan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowName: PropTypes.string.isRequired,
  why_text: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return question
    ? {
        value: question.rows[ownProps.rowIndex].why.value,
      }
    : {};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(matrixWhyChange(e.target.value, ownProps.rowIndex, ownProps.id)),
});

const ConnectedWhyField = connect(mapStateToProps, mapDispatchToProps)(
  MatrixWhyField
);

export default ConnectedWhyField;
